import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLayerGroup } from "@fortawesome/free-solid-svg-icons";
import SectionHeader from "./SectionHeader";
import CarrierReportPanel from "./CarrierReportPanel";
import { carrierBadgeClass } from "../presentation";

function ProcessedFileCard({ file }) {
  return (
    <div className="rounded-2xl border border-slate-200 p-4 transition-colors hover:border-slate-300">
      <div className="flex flex-wrap items-center gap-2">
        <p className="min-w-0 truncate text-sm font-semibold text-slate-900">
          {file.fileName}
        </p>
        <span
          className={`flex-shrink-0 rounded-full px-2.5 py-0.5 text-xs font-semibold ring-1 ${carrierBadgeClass(
            file.carrier
          )}`}
        >
          {file.carrier}
        </span>
        {file.detectedCarrier !== file.carrier && (
          <span className="flex-shrink-0 rounded-full bg-amber-50 px-2.5 py-0.5 text-xs font-semibold text-amber-700 ring-1 ring-amber-200">
            Override from {file.detectedCarrier}
          </span>
        )}
        {file.reportingPeriod && (
          <span className="flex-shrink-0 rounded-full bg-slate-100 px-2.5 py-0.5 text-xs font-semibold text-slate-600 ring-1 ring-slate-200">
            {file.reportingPeriod}
          </span>
        )}
      </div>

      {file.error ? (
        <div className="mt-3 rounded-xl border border-red-200 bg-red-50 px-3 py-2.5 text-xs text-red-700">
          {file.error}
        </div>
      ) : file.saveSuccess === false ? (
        <div className="mt-3 rounded-xl border border-amber-200 bg-amber-50 px-3 py-2.5 text-xs text-amber-700">
          {file.saveMessage || "Snowflake save failed."}
        </div>
      ) : (
        <div className="mt-3 space-y-1.5">
          {file.sheetSummaries.map((sheet) => (
            <div
              key={`${file.fileName}-${sheet.name}`}
              className="flex items-center justify-between rounded-xl bg-slate-50 px-3 py-2 text-xs"
            >
              <span className="font-medium text-slate-700">{sheet.name}</span>
              <span className="rounded-full bg-slate-200 px-2 py-0.5 font-semibold text-slate-600">
                {sheet.rowCount} rows
              </span>
            </div>
          ))}
          <CarrierReportPanel report={file.carrierReport} />
        </div>
      )}
    </div>
  );
}

export default function ProcessedFilesList({ processedFiles }) {
  return (
    <section className="rounded-3xl border border-slate-200 bg-white p-5 shadow-sm">
      <SectionHeader
        icon={faLayerGroup}
        iconBg="bg-purple-50"
        iconColor="text-purple-600"
        title="Processed Files"
        subtitle="Sheet usage and detected carrier for each upload."
      />

      <div className="grid gap-4 sm:grid-cols-2">
        {processedFiles.length === 0 ? (
          <div className="col-span-full flex flex-col items-center gap-3 rounded-2xl border-2 border-dashed border-slate-200 bg-slate-50 py-12 text-center">
            <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-slate-100">
              <FontAwesomeIcon icon={faLayerGroup} className="text-xl text-slate-400" />
            </div>
            <p className="text-sm text-slate-500">No processed files yet.</p>
          </div>
        ) : (
          processedFiles.map((file) => (
            <ProcessedFileCard
              key={`${file.fileName}-${file.carrier}-${file.error || "ok"}`}
              file={file}
            />
          ))
        )}
      </div>
    </section>
  );
}
